import * as React from "react";
const SvgFiRrViolin = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-violin_svg__a)">
      <path
        fill="#062147"
        d="M23.677 1.737A.999.999 0 1 0 22.263.323L17.24 5.347a6.795 6.795 0 0 0-8.024-.068 2.6 2.6 0 0 0-1.139 2.273c.04.728-.379 1.36-1.243 1.879-.838.503-1.603.63-2.268.385a2.6 2.6 0 0 0-3.018.927 8.37 8.37 0 0 0 .908 10.794 8.367 8.367 0 0 0 10.792.91 2.596 2.596 0 0 0 .928-3.021c-.249-.668-.12-1.433.382-2.27.52-.864 1.17-1.285 1.881-1.24a2.58 2.58 0 0 0 2.277-1.139 6.79 6.79 0 0 0-.065-8.015l5.026-5.026zm-6.613 11.916a.62.62 0 0 1-.512.266c-.866-.049-2.488.173-3.709 2.209-1.035 1.726-.865 3.127-.54 3.997a.59.59 0 0 1-.212.692 6.365 6.365 0 0 1-7.447-.047l1.063-1.062a.999.999 0 1 0-1.414-1.414L3.23 19.358a6.36 6.36 0 0 1-.05-7.456.59.59 0 0 1 .691-.21c.868.322 2.267.49 3.992-.546 2.033-1.22 2.258-2.844 2.21-3.703-.01-.195.092-.391.306-.537a4.81 4.81 0 0 1 5.43-.128l-5.515 5.515a.999.999 0 1 0 1.414 1.414l5.512-5.512c1.056 1.63 1.045 3.777-.155 5.458M16.97 1.53a1.5 1.5 0 1 1 3.001 0 1.5 1.5 0 0 1-3 0m7 4a1.5 1.5 0 1 1-3-.002 1.5 1.5 0 0 1 3 .002M9.707 16.294a.999.999 0 1 1-1.414 1.413l-2-2a.999.999 0 1 1 1.414-1.414z"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-violin_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrViolin;
